





















import { Vue, Component, Prop } from 'vue-property-decorator'

import Command from '@/comps/Command.vue'

import 'semantic-ui-css/components/segment.min.css'
import 'semantic-ui-css/components/grid.min.css'

interface CommandGQLResponse {
  name: string,
  alternativeNames: string[],
  admin: boolean,
  usage: string,
  nsfw: boolean,
  description: string
}

@Component({ components: { Command } })
export default class Module extends Vue {
  @Prop(String) readonly name!: string
  @Prop(Array) readonly commands!: CommandGQLResponse[]
  @Prop(Boolean) readonly showNSFW!: boolean
  @Prop(Boolean) readonly showAdmin!: boolean
  active: boolean = false
  onlyHasNSFW = this.commands.every((itm) => { return itm.nsfw })
  onlyHasAdmin = this.commands.every((itm) => { return itm.admin })
}
